/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Not_DoneInputs */

const en_us2_workout_quick_not_done = /** @type {(inputs: Workout_Quick_Not_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not done`)
};

const pt_br2_workout_quick_not_done = /** @type {(inputs: Workout_Quick_Not_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não feito`)
};

const es_419_workout_quick_not_done = /** @type {(inputs: Workout_Quick_Not_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hecho`)
};

const pt_pt2_workout_quick_not_done = /** @type {(inputs: Workout_Quick_Not_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não feito`)
};

const fr_fr2_workout_quick_not_done = /** @type {(inputs: Workout_Quick_Not_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas fait`)
};

const de_de2_workout_quick_not_done = /** @type {(inputs: Workout_Quick_Not_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht gemacht`)
};

const it_it2_workout_quick_not_done = /** @type {(inputs: Workout_Quick_Not_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non fatto`)
};

/**
* | output |
* | --- |
* | "Not done" |
*
* @param {Workout_Quick_Not_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_not_done = /** @type {((inputs?: Workout_Quick_Not_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Not_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_not_done(inputs)
	if (locale === "es-419") return es_419_workout_quick_not_done(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_not_done(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_not_done(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_not_done(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_not_done(inputs)
	return en_us2_workout_quick_not_done(inputs)
});
export { workout_quick_not_done as "workout-quick.not_done" }